// Stage numbers match the persisted `onboardingSetup.stageN` keys. Stage 2
// (Website) is retired: orgs go from Organization straight to AI Assistant,
// and the stepper numbers the remaining stages 1-5 without a gap.

export const ONBOARDING_STAGES = [
  'Organization',
  'AI Assistant',
  'IDX & Email',
  'Integrations',
  'Review',
];

const RETIRED_WEBSITE_STAGE = 2;

type StageProgress = { completed?: boolean } | undefined;

export type OnboardingSetupProgress = Partial<Record<`stage${number}`, StageProgress>>;

/** Stage to show from saved progress: 0 = welcome, 1-6 = persisted stage number. */
export const getStageFromSetup = (setup: OnboardingSetupProgress | null | undefined): number => {
  if (!setup || Object.keys(setup).length === 0) return 0;

  if (setup.stage5?.completed) return 6; // CRM done → Review
  if (setup.stage4?.completed) return 5; // IDX done → CRM
  if (setup.stage3?.completed) return 4; // AI Assistant (incl. Twilio) done → IDX
  if (setup.stage1?.completed) return 3; // Organization done → AI Assistant (skips Website)

  // Has onboarding data but no stages completed yet → Organization (skip welcome)
  return 1;
};

/** Maps a persisted stage number to its 1-based position in ONBOARDING_STAGES. */
export const toStepperStage = (stage: number): number =>
  stage > RETIRED_WEBSITE_STAGE ? stage - 1 : stage;
